import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, Form, FormField, Input, Link, SegmentedControl, SpaceBetween, StatusIndicator } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { formatRut, validateRut } from '@fdograph/rut-utilities';
import React from 'react';
import DPModal from '../../../../../components/DPModal';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import ConfirmDelete from '../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../components/extras/Favorites';
import SelectEquipment, { SelectEquipmentHandle } from '../../../../../components/selects/selectEquipment';
import SelectUser, { SelectUserHandle } from '../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnDanger, ItemEquipment, ItemsMovement, ItemUser } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';

type ItemFuel = {
    counterStart: number,
    counterEnd: number,
    liters: number,
    price?: number | null,
    idEquipment: number,
    registration: string,
}
export const OPSFuelSaleJP1 = () => {
    const { menu } = useGlobalState();

    const [fuel, setFuel] = useState<ItemFuel>({ counterStart: 100, counterEnd: 0, liters: 0, price: 0, idEquipment: 0, registration: "" });
    const [dateOpen, setDateOpen] = useState(false);
    const [type, setType] = useState("");
    const [isInvalidSale, setIsInvalidSale] = useState(true);
    const [isVoid, setIsVoid] = useState(false);
    const [showVoid, setShowVoid] = useState(false);
    const [movement, setMovement] = useState<ItemsMovement>();
    const [user, setUser] = useState<ItemUser>();
    const [equipment, setEquipment] = useState<ItemEquipment>();
    useGlobalState();
    const litersRef = useRef<HTMLInputElement>(null);
    const userRef = useRef<SelectUserHandle>(null);
    const equipmentRef = useRef<SelectEquipmentHandle>(null);
    const { navigate } = useRouter();


    const [payment, setPayment] = useState("");
    const [paymentOptions, setPaymentOptions] = useState([
        { id: "NONE", text: "No abona", disabled: false },
        { id: "CREDIT", text: "Crédito", disabled: false },
        { id: "DEBIT", text: "Débito", disabled: false },
        { id: "TRANSFER", text: "Transferencia", disabled: false },
        { id: "TANK", text: "Estanque", disabled: false },
    ]);
    const [tbkCodAuto, setTbkCodAuto] = useState("");
    const [RUT, setRUT] = useState("");
    const [RUTs, setRUTs] = useState<string[]>([]);
    const [email, setEmail] = useState("");






    const handleLitersFocus = () => {
        setTimeout(() => {
            litersRef.current?.focus(); // focus the input
            litersRef.current?.select(); // select all text
        }, 1);
    };
    const handleEquipmentFocus = () => {
        setTimeout(() => equipmentRef.current?.focus(), 1);
    }
    const handleUserFocus = () => {
        setTimeout(() => userRef.current?.focus(), 1);
    }
    const dataReset = () => {
        setMovement(prev => ({
            ...(prev || {}),
            receipt: "",
            data: "",
            idUser: 0,
            obs: "",

        } as ItemsMovement));
        setFuel({ counterStart: 0, counterEnd: 0, liters: 0, price: 0, idEquipment: 0, registration: "" })
        setPayment("")
        setRUT("")
        setEmail("")
        setTbkCodAuto("")
        setType("")
        setMovement(undefined)
    }

    const handleVoid = async () => {
        try {
            setLoading(true)
            let body = {
                idMovement: 0,
                isFuel: 1,
                type: type,
                idUser: movement?.idUser,
                receipt: movement?.receipt,
                ammount: 0,
                dateTransaction: movement?.dateTransaction,
                data: `ANULACIÓN FOLIO COMBUSTIBLE ${type} #${movement?.receipt}`,
                tbkCodAuto: tbkCodAuto,
                RUT: RUT,
                email: email,
                payment: payment,
                jsonMovement: {
                    idEquipment: 0,
                    registration: "",
                    counterStart: 0,
                    counterEnd: 0,
                    liters: 0,
                    price: 0,
                }
            }
            //console.log(body)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/fuel/void',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code === 0) {
                dataReset()
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const handleAddFuelSale = async () => {
        if (fuel && fuel.liters && fuel.liters > 0) {
            try {
                setLoading(true)
                let body = {
                    idMovement: 0,
                    isFuel: 1,
                    ammount: fuel.price * fuel.liters * -1,
                    type: type,
                    idUser: movement?.idUser,
                    data: movement?.data,
                    obs: movement?.obs,
                    invoice: {
                        type: payment,
                        RUT: RUT,
                        email: email,
                        tbkCodAuto: tbkCodAuto
                    },
                    receipt: movement?.receipt,
                    tbkCodAuto: tbkCodAuto,
                    dateTransaction: movement?.dateTransaction,
                    idEquipment: fuel?.idEquipment,
                    payment: payment,
                    fuelType: type,
                    jsonMovement: {
                        counterStart: fuel?.counterStart,
                        counterEnd: fuel?.counterEnd,
                        liters: fuel?.liters,
                        price: fuel?.price,
                        idEquipment: fuel?.idEquipment,
                        registration: fuel?.registration,
                    },
                    jsonDocuments: {
                        type: "FEV",
                        email: email,
                        RUT: RUT,
                        number: 0,
                        token: "",
                        file: "",
                        reference: 0,
                        VAT: 19,
                        lines: [{
                            product: movement?.data,
                            price: fuel.price,
                            qty: fuel.liters,
                            subTotal: fuel.price * fuel.liters
                        }],
                        dte: null as any
                    }
                }
                if (payment === "TANK") {
                    delete body.jsonDocuments
                    body.obs = "Estanque/Saldo. " + body.obs ? body.obs : "";
                    body.ammount = 0;
                }

                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/fuel/add',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify(body)
                })


                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    dataReset()
                }
            } catch (error: any) {

            } finally {
                setLoading(false)
            }
        }
    }
    const handleGetFuelParameteres = async () => {
        try {
            setLoading(true)

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/fuel/counters',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    type: type,
                    idUser: movement?.idUser
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0 && data.fuel) {
                setIsVoid(data.fuel.void)
                setFuel(prev => ({
                    ...(prev || {}),
                    counterStart: data.fuel.counterStart,
                    price: data.fuel.price,
                } as ItemFuel));
                setPayment(data.fuel.price === 0 ? "NONE" : "")

                setMovement(prev => ({
                    ...(prev || {}),
                    receipt: data.fuel.receipt,
                } as ItemsMovement));


            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        if (movement && movement?.idUser && movement?.idUser > 0)
            handleGetFuelParameteres()
    }, [movement?.idUser]);
    useEffect(() => {
        dataReset();
    }, []);


    useEffect(() => {
        let disabled = false;
        if (movement) {
            if (type === "") disabled = true
            if (movement?.idUser === 0) disabled = true
            if (movement?.dateTransaction === "") disabled = true
            if (fuel.idEquipment === 0) disabled = true
            if (fuel.liters === 0) disabled = true
            if (fuel.liters !== fuel.counterEnd - fuel.counterStart) disabled = true
            if (payment === "") disabled = true
            if (payment !== "NONE") {
                if (RUT === "" || email === "") disabled = true
                if ((payment === "DEBIT" || payment === "CREDIT") && tbkCodAuto.length !== 6) disabled = true
            }
        }
        setIsInvalidSale(disabled)
    }, [movement, email, payment, RUT, tbkCodAuto, fuel]);

    useEffect(() => {

        if (
            movement?.receipt !== "" &&
            fuel.registration !== "" &&
            fuel.liters > 0 &&
            fuel.price != null && // ensures price is not null or undefined
            fuel.price >= 0 &&
            fuel.counterEnd > 0
        ) {
            const data = `COMBUSTIBLE ${type} VALE ${movement?.receipt}; ${fuel.liters} LTS X ${formatCurrency(fuel.price, "CLP")} (${fuel.registration})`;
            setMovement(prev => ({
                ...(prev || {}),
                data: data
            } as ItemsMovement));
        } else {

            setMovement(prev => ({
                ...(prev || {}),
                data: ""
            } as ItemsMovement));
        }
    }, [
        movement?.receipt,
        fuel.registration,
        fuel.liters,
        fuel.price,
        fuel.counterEnd
    ]);
    function calculateRemanent() {
        if (fuel.counterEnd > 0 && fuel.liters > 0 && (fuel.counterStart + fuel.liters) !== fuel.counterEnd) {
            let largoIni = fuel.counterStart.toString().length;
            let largoFin = fuel.counterEnd.toString().length;
            let temp = fuel.counterStart.toString().substring(0, largoIni - largoFin);
            let temp2 = parseInt(temp + '' + fuel.counterEnd.toString())
            if (temp2 - fuel.liters === fuel.counterStart) {
                setFuel(prev => ({
                    ...(prev || {}),
                    counterEnd: temp2
                } as ItemFuel));
            }
        }
    }
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <Form actions={
                        movement?.idUser > 0 && (
                            <SpaceBetween direction='horizontal' size="xs">
                                {isVoid ?
                                    <Button disabled={!movement || movement?.dateTransaction === ""} disabledReason='Debe seleccionar la fecha de anulación' style={{ root: btnDanger }} onClick={() => setShowVoid(true)}>Anular folio</Button> : null}
                                <Button variant='primary' disabled={isInvalidSale} onClick={() => handleAddFuelSale()}>Generar venta</Button>
                            </SpaceBetween>
                        )
                    } header={<Header variant="h1" actions={<Favorites />}>Venta de combustibles</Header>}>
                        <SpaceBetween direction='vertical' size="m">
                            <SegmentedControl
                                selectedId={type}
                                onChange={({ detail }) => {
                                    setMovement(prev => ({ ...(prev || {}), idUser: 0, receipt: "0", dateTransaction: "", data: "" } as ItemsMovement));
                                    setFuel(prev => ({ ...(prev || {}), liters: 0, counterEnd: 0, counterStart: 0, idEquipment: 0, price: undefined, registration: "" } as ItemFuel));
                                    setType(detail.selectedId);
                                    handleUserFocus();

                                }}
                                label="Tipo combustible"
                                options={[
                                    { text: "AVGAS", id: "AVGAS" },
                                    { text: "JP1", id: "JP1" },
                                ]}
                            />
                            {type !== "" && (
                                <SpaceBetween direction='vertical' size="m">
                                    <FormField label="Usuario">
                                        <SelectUser
                                            ref={userRef}
                                            value={movement?.idUser || 0} onConfirm={(user) => {
                                                if (user) {
                                                    setMovement(prev => ({ ...(prev || {}), idUser: user.idUser } as ItemsMovement));
                                                    handleEquipmentFocus()
                                                    setRUT(user.RUT)
                                                    setUser(user)
                                                    setEmail(user.email)

                                                }
                                                else
                                                    setMovement(prev => ({ ...(prev || {}), idUser: 0 } as ItemsMovement));
                                            }} />
                                    </FormField>

                                    <SpaceBetween direction='horizontal' size="l">
                                        <div style={{ minWidth: 200 }}>
                                            <FormField label={"Folio"}
                                            >
                                                <Link variant="awsui-value-large">{typeof movement?.receipt === "number" && movement.receipt > 0 ? movement.receipt : "- - - -"}</Link>
                                            </FormField>
                                        </div>
                                        <div style={{ minWidth: 200 }}>
                                            <FormField label={"Precio venta"}>
                                                <Link variant="awsui-value-large">
                                                    {typeof fuel?.price === "number" && fuel.price >= 0 ? formatCurrency(fuel.price, "CLP") : "- - - -"}
                                                </Link>
                                            </FormField>
                                        </div>
                                        <div style={{ minWidth: 200 }}>

                                            <FormField label={"Venta total"}>
                                                <Link variant="awsui-value-large">
                                                    {typeof fuel?.price === "number" && typeof fuel?.liters === "number" && fuel.price >= 0 && fuel.liters > 0 && fuel.counterEnd > 0 ? formatCurrency(fuel.price * fuel.liters, "CLP") : "- - - -"}
                                                </Link>
                                            </FormField>
                                        </div>

                                    </SpaceBetween>
                                    {movement?.idUser && movement.idUser > 0 ? (
                                        <>
                                            <Header variant="h3">Cliente</Header>
                                            <SpaceBetween direction='horizontal' size="xs">

                                                <FormField label="Aeronave">
                                                    <SelectEquipment ref={equipmentRef} value={fuel?.idEquipment || 0} onConfirm={(equipment) => {
                                                        if (equipment) {
                                                            setFuel(prev => ({ ...(prev || {}), idEquipment: equipment.idEquipment, registration: equipment.registration } as ItemFuel));
                                                            if (movement.dateTransaction === "") setDateOpen(true)
                                                            setEquipment(equipment)
                                                            if (equipment.jsonSII && equipment.jsonSII.rut && equipment.jsonSII.rut !== "") {
                                                                setRUT(equipment.jsonSII.rut)
                                                            }
                                                        } else {
                                                            setFuel(prev => ({ ...(prev || {}), idEquipment: 0, registration: "" } as ItemFuel));
                                                        }
                                                    }} />
                                                </FormField>
                                                <FormField label="Fecha contable">
                                                    <DPModal date={movement?.dateTransaction || ""} today yesterday

                                                        end={new Date()}
                                                        onConfirm={(date) => {
                                                            setMovement(prev => ({ ...(prev || {}), dateTransaction: date } as ItemsMovement));
                                                        }}
                                                    />
                                                </FormField>

                                            </SpaceBetween>

                                            {movement.idUser && movement.idUser > 0 && fuel && fuel.idEquipment > 0 && movement.dateTransaction && movement.dateTransaction !== "" ? (
                                                <>

                                                    <Header variant="h3">Consumo</Header>
                                                    <SpaceBetween direction='horizontal' size="xs">
                                                        <FormField label="Numeral inicial">
                                                            <Input type='number' key={"counterStart"}
                                                                value={fuel?.counterStart.toString() || "0"}
                                                                readOnly
                                                            />
                                                        </FormField>
                                                        <FormField label="Litros">
                                                            <Input type='number' key={"liters"}
                                                                ref={litersRef}
                                                                value={fuel?.liters?.toString() || "0"}
                                                                onChange={(detail) => {
                                                                    if (fuel) {
                                                                        setFuel(prev => ({
                                                                            ...(prev || {}),
                                                                            liters: Number(detail.detail.value)
                                                                        } as ItemFuel));
                                                                    }
                                                                }}
                                                            />
                                                        </FormField>
                                                        <FormField label="Numeral final">
                                                            <Input type='number' key={"counterEnd"}
                                                                value={fuel?.counterEnd?.toString() || "0"}
                                                                onChange={(detail) => {
                                                                    setFuel(prev => ({
                                                                        ...(prev || {}),
                                                                        counterEnd: Number(detail.detail.value)
                                                                    } as ItemFuel));
                                                                }}
                                                                onBlur={() => {
                                                                    calculateRemanent();
                                                                }}
                                                            />
                                                        </FormField>

                                                    </SpaceBetween>
                                                    {fuel.counterEnd - fuel.liters !== fuel.counterStart && (
                                                        <StatusIndicator type="error">Litros v/s numeral final no coinciden</StatusIndicator>
                                                    )}
                                                    <SpaceBetween direction='vertical' size="xs">
                                                        <FormField label="Concepto">
                                                            <Input key={"concept"}
                                                                value={movement?.data}
                                                                readOnly
                                                            />
                                                        </FormField>
                                                        <FormField label="Observaciones" constraintText={"Opcional"}>
                                                            <Input key={"obs"}
                                                                value={movement?.obs || ""}
                                                                onChange={(detail) => {
                                                                    setMovement(prev => ({
                                                                        ...(prev || {}),
                                                                        obs: detail.detail.value
                                                                    } as ItemsMovement));
                                                                }}
                                                            />
                                                        </FormField>
                                                        {fuel && fuel.price > 0 && (

                                                            <SegmentedControl
                                                                selectedId={payment}
                                                                onChange={({ detail }) => {
                                                                    setPayment(detail.selectedId)
                                                                    if (detail.selectedId !== "DEBIT" && detail.selectedId !== "CREDIT") {
                                                                        setTbkCodAuto("")
                                                                    }
                                                                }}
                                                                label="Forma pago"
                                                                options={paymentOptions}
                                                            />
                                                        )}
                                                    </SpaceBetween>
                                                </>
                                            ) : null}


                                            {movement.idUser && movement.idUser > 0 && fuel && fuel.idEquipment > 0 && movement.dateTransaction && movement.dateTransaction !== "" && payment !== "" ? (
                                                <>
                                                    {payment !== "TANK" && (

                                                        <SpaceBetween direction='vertical' size="xs">
                                                            <Header variant="h3">Facturación</Header>
                                                            <SpaceBetween direction='horizontal' size="xs">
                                                                <FormField label="RUT facturación"
                                                                    constraintText={
                                                                        <>
                                                                            <Link onClick={() => setRUT(user?.RUT || "")}><BadgeCustom color={user?.RUT === RUT ? "blue" : "light"}>{user?.RUT}</BadgeCustom></Link>
                                                                            {equipment && equipment.jsonSII && equipment.jsonSII.rut && equipment.jsonSII.rut !== "" && (
                                                                                <Link onClick={() => setRUT(equipment.jsonSII.rut)}><BadgeCustom color={equipment.jsonSII.rut === RUT ? "blue" : "light"}>{equipment.jsonSII.rut}</BadgeCustom></Link>
                                                                            )}
                                                                        </>
                                                                    }
                                                                >
                                                                    <Input key={"RUT"}
                                                                        value={RUT}
                                                                        onChange={(detail) => {
                                                                            setRUT(detail.detail.value.trim())
                                                                        }}
                                                                        onBlur={() =>
                                                                            setRUT(validateRut(RUT) ? formatRut(RUT) : "")
                                                                        }
                                                                    />
                                                                </FormField>
                                                                <FormField label="Email">
                                                                    <Input key={"Email"}
                                                                        value={email}
                                                                        onChange={(detail) => {
                                                                            setEmail(detail.detail.value.trim())
                                                                        }}
                                                                    />
                                                                </FormField>
                                                                {payment === "DEBIT" || payment === "CREDIT" ? (
                                                                    <FormField label="Código autorización">
                                                                        <Input key={"tbkCodAuto"}
                                                                            value={tbkCodAuto}
                                                                            onChange={(detail) => {
                                                                                let tbk = detail.detail.value.trim().toUpperCase();
                                                                                tbk = tbk.replace(/[^A-Z0-9]/gi, '');
                                                                                if (tbk.length > 6) {
                                                                                    tbk = tbk.substring(0, 6)
                                                                                }
                                                                                setTbkCodAuto(tbk)
                                                                            }}

                                                                        />
                                                                    </FormField>
                                                                ) : null}
                                                            </SpaceBetween>


                                                        </SpaceBetween>
                                                    )}
                                                </>
                                            ) : null}

                                        </>
                                    ) : null}


                                </SpaceBetween>
                            )}
                        </SpaceBetween>
                    </Form>
                    <ConfirmDelete header='Anular folio' subtitle={`Desea anular el folio ${movement?.receipt} correspondiente a la venta de combustible ${type}`} show={showVoid} confirmWord={`anular ${movement?.receipt}`} action={'Solicitar anulación'} warning={''} onConfirm={() => handleVoid()} onDismiss={() => setShowVoid(false)} />

                </>
            }
        />
    );
};
